module.exports = __webpack_public_path__ + "52627c7b844cb65e7e80a8a01d1031e8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/spaceship-s.png
// module id = 2738
// module chunks = 0